export default __webpack_public_path__ + "static/media/140.cda4c84b.svg";